import { Col, Row } from 'reactstrap';
import { useIntl } from 'react-intl';
import PeriodoData from 'src/paginas/data/periodo-data';
import EstagioLookup from 'src/lookups/DetalhamentoFinanceiroEstagioLookup';

const Search = ({ model }) => {
  const intl = useIntl();

  const handleChangeFiltro = (field, value) => {
    model.getModel(field).requestChange(value);
  };

  return (
    <>
      <Row>
        <Col md={6}>
          <EstagioLookup
            model={{
              label: intl.formatMessage({ id: 'estagio' }),
              value: model.getModel('estagio').value,
              requestChange: model.getModel('estagio').requestChange,
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <PeriodoData
            clearable={true}
            tipoFiltroData={model.getModel('tipoFiltroData').value}
            dataInicio={model.getModel('dataInicio').value}
            dataTermino={model.getModel('dataTermino').value}
            data={{ idsIgnorados: [7] }}
            onChange={handleChangeFiltro}
          />
        </Col>
      </Row>
    </>
  );
};

export default Search;
